import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// Component
import { GenericIntegrationsComponent } from './generic-integrations.component';
import { TableLikeComponent } from './components/table-like/table-like.component';
import { StaticFormComponent } from './components/components/static-form/static-form.component';
// Guards & Services
import { ComponentFactoryResolverService, RoleGuard } from '@cv-invision/core';
import { GenericIntegrationLoaderGuard } from './providers/generic-integration-loader.guard';
import { GenericHeaderComponent } from './header/generic-header.component';
import { OutgoingEventsHybridTabsComponent } from './components/outgoing-events-hybrid-tabs/outgoing-events-hybrid-tabs.component';

const routes: Routes = [
	{
		path: 'generic-integration',
		canActivate: [RoleGuard],
		canActivateChild: [GenericIntegrationLoaderGuard],
		component: GenericIntegrationsComponent,
		resolve: {
			componentFactoryResolver: ComponentFactoryResolverService
		},
		data: {
			module: 'generic-integrations',
			keepBreadcrumb: true
		},
		children: [
			{
				path: ':integrationId/organization/:organizationIntegrationId/mapper/:mapperType',
				component: TableLikeComponent,
				data: {
					subComponentShow: false,
					breadcrumbComponent: GenericHeaderComponent,
					breadcrumbComponentData: {
						title: 'Back to Organizations list',
						backButton: {
							show: true
						}
					}
				}
			},
			{
				path: ':integrationId/organization/:organizationIntegrationId/form/:section',
				component: StaticFormComponent,
				data: {
					subComponentShow: false,
					breadcrumbComponent: GenericHeaderComponent,
					breadcrumbComponentData: {
						title: 'Back to Organizations list',
						backButton: {
							show: true
						}
					}
				}
			},
			{
				path: ':integrationId/organization/:organizationIntegrationId/:section',
				component: TableLikeComponent,
				data: {
					subComponentShow: false,
					breadcrumbComponent: GenericHeaderComponent,
					breadcrumbComponentData: {
						title: 'Back to Organizations list',
						backButton: {
							show: true
						}
					}
				}
			},
			{
				path: ':integrationId/organization/:organizationIntegrationId/special/:section',
				component: OutgoingEventsHybridTabsComponent,
				data: {
					subComponentShow: false,
					breadcrumbComponent: GenericHeaderComponent,
					breadcrumbComponentData: {
						title: 'Back to Organizations list',
						backButton: {
							show: true
						}
					}
				}
			},
			{
				path: ':integrationId/mapper/:mapperType',
				component: TableLikeComponent,
				data: {
					subComponentShow: false,
					breadcrumbComponent: GenericHeaderComponent,
					breadcrumbComponentData: {
						title: 'Back to Select Integration',
						backButton: {
							show: true
						}
					}
				}
			},
			{
				path: ':integrationId/form/:section',
				component: StaticFormComponent,
				data: {
					subComponentShow: false,
					breadcrumbComponent: GenericHeaderComponent,
					breadcrumbComponentData: {
						title: 'Back to Select Integration',
						backButton: {
							show: true
						}
					}
				}
			},
			{
				path: ':integrationId/:section',
				component: TableLikeComponent,
				data: {
					subComponentShow: false,
					breadcrumbComponent: GenericHeaderComponent,
					breadcrumbComponentData: {
						title: 'Back to Select Integration',
						backButton: {
							show: true
						}
					}
				}
			},
			{
				path: ':integrationId/special/:section',
				component: OutgoingEventsHybridTabsComponent,
				data: {
					subComponentShow: false,
					breadcrumbComponent: GenericHeaderComponent,
					breadcrumbComponentData: {
						title: 'Back to Select Integration',
						backButton: {
							show: true
						}
					}
				}
			},
		]
	}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GenericIntegrationsRoutingModule { }
